import React, { useState } from 'react';
import { ArrowLeft, Lock } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import logo from '../assets/logo.png';
import api from '../lib/api';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!token) return setError('This reset link is missing or invalid.');
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirmPassword) return setError('Passwords do not match.');

    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, password });
      setSuccess(true);
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Unable to reset password. Please request a new link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", padding: "24px 16px", background: "var(--bg)", position: "relative" }}>
      <button onClick={() => navigate('/signin')} className="btn position-absolute" style={{ top: 20, left: 20, color: "var(--primary)", borderRadius: "50%" }} aria-label="Back to sign in">
        <ArrowLeft size={24} />
      </button>
      <div style={{ width: "100%", maxWidth: "400px", borderRadius: "22px", background: "#fff", border: "1px solid #ececf5", boxShadow: "0 12px 36px rgba(80, 0, 200, 0.09)", padding: "32px 28px", textAlign: "center" }}>
        <img src={logo} alt="Logo" style={{ width: 64 }} />
        <div className="d-flex justify-content-center align-items-center mt-3" style={{ width: 80, height: 80, borderRadius: '50%', margin: '0 auto', background: "color-mix(in srgb, var(--primary) 12%, white)" }}>
          <Lock size={35} color="var(--primary)" />
        </div>
        {success ? (
          <>
            <h5 className="mt-4 fw-semibold" style={{ color: "#171b2d", fontSize: "22px" }}>Password updated</h5>
            <p style={{ color: '#73798a', fontSize: '0.9em', lineHeight: 1.5 }}>Your password has been reset successfully.</p>
            <button onClick={() => navigate('/signin')} className="btn w-100 btn-accent" style={{ padding: 12, borderRadius: 10, fontWeight: 600 }}>Back to Sign In</button>
          </>
        ) : (
          <form className="text-start" onSubmit={handleSubmit}>
            <h5 className="mt-4 fw-semibold text-center" style={{ color: "#171b2d", fontSize: "22px" }}>Create a new password</h5>
            <label className="fw-semibold mb-1" style={{ color: "#2f374d", fontSize: 13 }}>New password</label>
            <input type="password" className="form-control mb-3" style={{ border: "1px solid #e4e5ee", borderRadius: 10, padding: "12px", outlineColor: "var(--primary)" }} value={password} onChange={(event) => setPassword(event.target.value)} minLength={8} required />
            <label className="fw-semibold mb-1" style={{ color: "#2f374d", fontSize: 13 }}>Confirm password</label>
            <input type="password" className="form-control" style={{ border: "1px solid #e4e5ee", borderRadius: 10, padding: "12px", outlineColor: "var(--primary)" }} value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} minLength={8} required />
            {error && <div className="text-danger mt-2" role="alert">{error}</div>}
            <button type="submit" className="btn w-100 mt-3 btn-accent" disabled={loading} style={{ padding: 12, borderRadius: 10, fontWeight: 600 }}>{loading ? 'Updating...' : 'Update Password'}</button>
          </form>
        )}
      </div>
    </div>
  );
}